import Vue from 'vue';
import { mapMutations } from 'vuex';
export default Vue.extend({
    props: {
        product: Object,
    },
    created() {
        this.setCurrentProduct(this.product);
        this.setDefaultOrFirstVariant();
    },
    methods: {
        ...mapMutations('productModule', ['setCurrentProduct']),
        ...mapMutations('productModule', ['setCurrentVariant']),
        setDefaultOrFirstVariant() {
            const defaultVariant = this.product.variants.find((x) => x.is_default);
            if (defaultVariant) {
                this.setCurrentVariant(defaultVariant);
            }
            else {
                this.setCurrentVariant(this.product.variants[0]);
            }
        },
    },
    render(h) {
        return h();
    },
});
